import { useState, type FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/daeoqgptto0ceqqnh1og';

export default function Newsletter() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // honeypot check: silently ignore bots
    const hp = (fd.get('contact_alt') || '').toString().trim();
    if (hp) {
      setStatus('success');
      setMessage('订阅成功！最新恋情瓜会第一时间推送到你的邮箱。');
      form.reset();
      return;
    }

    const params = new URLSearchParams();
    fd.forEach((v, k) => {
      if (k !== 'contact_alt' && v) params.append(k, v.toString());
    });

    setStatus('loading');
    setMessage('');
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
      const isSpam =
        /spam|form data is spam/i.test(serverMsg) ||
        /spam|form data is spam/i.test(text);
      const ok = res.ok && parsed?.code === 'OK';

      if (ok && !isSpam) {
        setStatus('success');
        setMessage('订阅成功！最新恋情瓜会第一时间推送到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(
          isSpam
            ? '提交过于频繁，请稍后再试。'
            : serverMsg || '订阅失败，请检查邮箱后重试。',
        );
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试。');
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600" />
      <div className="pointer-events-none absolute -right-20 -top-10 h-72 w-72 rounded-full bg-background-50/10 blur-3xl" />
      <div className="relative mx-auto max-w-[760px] px-4 py-16 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-mail-send-line" />
          吃瓜速报 · 免费订阅
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
          一键订阅，新瓜不迟到
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-background-50/90">
          恋情公开、约会实锤、分手复合的每一次重大进展，都会整理成速报第一时间推送到你的邮箱。只发干货，绝不打扰。
        </p>

        <form
          data-readdy-form="true"
          onSubmit={onSubmit}
          className="mx-auto mt-7 flex max-w-md flex-col gap-3 sm:flex-row sm:items-center"
        >
          <label className="sr-only" htmlFor="news-email">
            邮箱地址
          </label>
          <input
            id="news-email"
            type="email"
            name="email"
            required
            maxLength={120}
            placeholder="输入你的邮箱地址"
            autoComplete="email"
            className="w-full rounded-md border border-background-50/30 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-background-50/70"
          />
          <input
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="extra-input"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 disabled:opacity-70"
          >
            {status === 'loading' ? (
              <i className="ri-loader-4-line animate-spin text-base" />
            ) : (
              '立即订阅'
            )}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1.5 text-sm text-background-50">
            <i className="ri-checkbox-circle-line" />
            {message}
          </p>
        )}
        {status === 'error' && (
          <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1.5 text-sm text-background-50">
            <i className="ri-error-warning-line" />
            {message}
          </p>
        )}
        <p className="mt-3 text-xs text-background-50/70">
          订阅即代表同意接收吃瓜速报，可随时退订。不收集你的其他信息。
        </p>
      </div>
    </section>
  );
}